import axios from 'axios';
import { camelCaseKeys } from 'utils/objects';

export async function fetchRegions() {
  try {
    const response = await axios.get('/regions');
    const data = camelCaseKeys(response.data, { deep: true });
    response.data = data;
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
}
